module.exports = new __parcel__URL__("globe.08b03b80.svg").toString();